import { render, staticRenderFns } from "./UsageItem.vue?vue&type=template&id=08e492fd&scoped=true"
import script from "./UsageItem.vue?vue&type=script&lang=js"
export * from "./UsageItem.vue?vue&type=script&lang=js"
import style0 from "./UsageItem.vue?vue&type=style&index=0&id=08e492fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e492fd",
  null
  
)

export default component.exports